
import Page from './common/page';
import cookies from "./cookies";

class GoogleTranslate {
    constructor() {
        this.state = {
            defaultCode: "ru",
            langCode:  "ru"
        }


        // add load event for window
        window.addEventListener('load', $.proxy(this.OnLoad, this));
        // change custom select
        // top menu select
        $('.translate-languages').change( this.onChange.bind(this))
        // top menu mobile view select
        $('.translate-languages__mb').change( this.onChange.bind(this))
        // footer menu select
        $('.translate-languages__f').change( this.onChange.bind(this))

        let translate = localStorage.getItem('translate');
        if(translate && window.location.hash.match('(Topic|Tag)\\w+') === null){
            const translate = "#googtrans(" + this.state.defaultCode + "|"+ JSON.parse(localStorage.getItem('lang-local')) +")";
            window.location = translate
            localStorage.setItem('translate', JSON.stringify(translate));
            this.setDefaultLang(this.state.langCode)
        }else if (window.location.hash.match('(Topic|Tag)\\w+')){
            return
        }else{
            const trans = "#googtrans(" + this.state.defaultCode + "|"+ this.state.langCode +")";
            window.location = trans;
            localStorage.setItem('translate', JSON.stringify(trans));
        }
    }

    setDefaultLang(value){
        // set value in google translate select
        $('.goog-te-combo').val(value)
        // mark option 'selected' in google translate select
        $('.goog-te-combo option').removeAttr('selected').filter('[value='+ value +']').attr('selected', true)
        // remove 'selected' attrs from all options and add selected one
        // top menu
        $('.translate-languages option').removeAttr('selected').filter('[value='+ value +']').attr('selected', true)
        // top menu mobile view
        $('.translate-languages__mb option').removeAttr('selected').filter('[value='+ value +']').attr('selected', true)
        // footer menu
        $('.translate-languages__f option').removeAttr('selected').filter('[value='+ value +']').attr('selected', true)
    }

    OnLoad(){

        let langLocalJSON = localStorage.getItem('lang-local');
        // let langListJSON = localStorage.getItem('lang-list');

        let  langLocal;

        // try{
        //     langList = JSON.parse(langListJSON)
        // }catch{
        //     langList = {}
        // }
        //
        // if(typeof langList !== "object" || langList === null) {
        //     langList = {}
        // }

        try{
            langLocal = JSON.parse(langLocalJSON)
        }catch {
            langLocal = this.state.langCode
        }

        if(typeof langLocal !== "string" || langLocal === null) {
            langLocal = this.state.langCode
        }


        this.state.langCode = langLocal;
        // localStorage.setItem('lang-local', JSON.stringify(this.state.langCode));
        document.cookie = "googtrans=/ru/" + this.state.langCode;

        let languageList;
        const languageListScriptTag = document.querySelector('script[id="language-list"]');
        try{
            languageList = JSON.parse(languageListScriptTag.innerText)
        }catch{
            languageList = {}
        }
        // console.log('languageList', languageList)

        // if no 'lang-list'
        // if(Object.keys(langList).length === 0)  {
        //     // render options in window
        //     let SetInterval = setInterval( () => {
        //         let GGL = window.ggl
        //         if(!GGL) {
        //             return
        //         }
        //         const languages = GGL.ib.tl
        //         localStorage.setItem('lang-list', JSON.stringify(languages));
        //         this.Languages(languages)
        //         clearInterval(SetInterval)
        //     }, 20)
        //
        //     setTimeout(() => {
        //         clearInterval(SetInterval)
        //     }, 5000)
        // }else{
            // render options in window
            this.Languages(languageList)
            this.setDefaultLang(this.state.langCode)
        // }

    }

    // render lang-list
    Languages(ggl){
        // find #googtrans(ru|*) in location
        let defaultSelected = this.state.langCode
        // convert lang-list in to Array
        var ArrayLang = Object.entries(ggl);
        // get first child in array (default value), write languages code in state
        // loop to generate options in custom select
        ArrayLang.forEach((item) => {
            // init option template
            var options = '<option translate="no" value=' + item[0] + ' '+ (item[0] === defaultSelected ? 'selected="selected"' : '') +'>' + item[1] + '</option>';
            // add option in custom select
            // top menu select
            $('.translate-languages').append(options);
            // top menu mobile view select
            $('.translate-languages__mb').append(options);
            // footer menu select
            $('.translate-languages__f').append(options);
        })
    }

    // change custom select
    onChange(e){
        // get value
        var value = e.target.value;

        this.setDefaultLang(value)

        // add lang in local storage
        localStorage.setItem('lang-local', JSON.stringify(value))
        // set value in state
        this.state.langCode = value
        // add #googtrans(ru|*) in location
        const googleTranslate = "#googtrans(" + this.state.defaultCode + "|"+ value +")";
        localStorage.setItem("translate", JSON.stringify(googleTranslate))
        window.location = googleTranslate
        // reload page
        location.reload();
    }

}

class GoogleForPages extends Page {
    init() {
        try{
            this.googleTranslate = new GoogleTranslate();
        }catch (e){
            document.querySelector('.header-submenu__languages').style.display = "none"
        }

    }
}

export default GoogleForPages;
